module.exports = __webpack_public_path__ + "img/logo_cts@3x.ed68bf48.png";